import { Controller } from "@hotwired/stimulus";
import { Turbo } from "@hotwired/turbo-rails";

export default class extends Controller {
  static values = { url: String };

  connect() {
    this.element.setAttribute("data-clickable-row-connected", "");
  }

  disconnect() {
    this.element.removeAttribute("data-clickable-row-connected");
  }

  click(event) {
    if (event.target.closest("a, button, input, label, [role='dialog']")) return;

    if (!window.getSelection().isCollapsed) return;

    if (event.metaKey || event.ctrlKey) {
      window.open(this.urlValue, "_blank");
    } else {
      Turbo.visit(this.urlValue);
    }
  }
}
